import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  // isMobileView = false; // Variável para controlar a exibição do menu móvel

  // // Verifica a largura da tela ao inicializar o componente e em mudanças de redimensionamento
  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   this.checkScreenWidth();
  // }

  // // Método para verificar a largura da tela e definir a variável isMobileView
  // checkScreenWidth() {
  //   this.isMobileView = window.innerWidth <= 1000; // Defina o limite de largura para dispositivos móveis
  // }

}
